import { render, staticRenderFns } from "./NaiPointApi.vue?vue&type=template&id=56a1bf55&scoped=true"
import script from "./NaiPointApi.vue?vue&type=script&lang=js"
export * from "./NaiPointApi.vue?vue&type=script&lang=js"
import style0 from "./NaiPointApi.vue?vue&type=style&index=0&id=56a1bf55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1bf55",
  null
  
)

export default component.exports